import React, { useCallback, useEffect, useState } from 'react';
import { useChatContext } from '../context/chat-context';
import { getAiSaver } from '../../../cms-api/ai';

const CustomerDocPicture = () => {

  const [status, setStatus] = useState(null);

  const [message, setMessage] = React.useState(null);

  const [codeMessage, setCodeMessage] = React.useState(null);

  const { createToken, commitCreateDoc, sendMessage, 
    getCodeCallback, setAddMessageFunc, setMessageStatusFunc,
    setIsSending } = useChatContext();

  const [inputValue, setInputValue] = useState("");

  const [isCreateCodeStart, setIsCreateCodeStart] = useState(false);

  const [isCancel, setIsCancel] = useState(false);

  // str add message to message string
  const addMessage = (str) =>
    setMessage((prev) => ({
      message: prev ? prev.message + str : str,
  }));

  const addCodeMessage = (str) =>
    setCodeMessage((prev) => ({
      message: prev ? prev.message + str : str,
    }));

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleClick = useCallback(async () => {
    setIsSending(true);
    setIsCreateCodeStart(true);
    setAddMessageFunc(addCodeMessage);
    commitCreateDoc(createToken.chat_token, inputValue, async () => {
      const saverData = await getAiSaver();
      sendMessage(JSON.stringify({
        "cms_token": saverData.token,
        "is_create_code_next": true,
      }));
    });
  }, [createToken, commitCreateDoc, inputValue, sendMessage, setIsCreateCodeStart, setAddMessageFunc, setIsSending]);

  const handleCancel = useCallback(async () => {
    const saverData = await getAiSaver();
    sendMessage(JSON.stringify({
      "cms_token": saverData.token,
      "is_create_code_cancel": true,
    }));
    setIsCreateCodeStart(false);
  }, [sendMessage, setIsCreateCodeStart]);

  useEffect(() => {
    setInputValue(message?.message);
  }, [message?.message])

  useEffect(() => {
    setAddMessageFunc(addMessage);
    setMessageStatusFunc(setStatus);
  }, [setAddMessageFunc, setMessageStatusFunc, setMessage])

  useEffect(() => {
    console.log('status:', status);
    if (status === "create_code:end") {
      getCodeCallback(createToken.chat_token);
      setStatus("close");
    }
  }, [status, createToken, setStatus, getCodeCallback]);

  return <>
    <div>
      <textarea
        disabled={!status || isCreateCodeStart || isCancel}
        value={inputValue}
        onChange={handleChange}
        placeholder="仕様を入力ください"
        style={{ marginRight: '8px' }}
      />
      {(status === "create_doc_code:wait" && !isCreateCodeStart && !isCancel) && <>
        <button type="button" onClick={handleClick}>コード作成</button>
        <button type="button" onClick={async () => {
          setIsCancel(true);
          await handleCancel();
        }}>キャンセル</button>
      </>}
      {!status && <p>仕様書作成中...</p>}
    </div>
    { isCreateCodeStart && codeMessage &&
      <div style={{
        backgroundColor: '#f0f0f0',
        color: '#333',
        padding: '10px',
        borderRadius: '10px',
        margin: '5px 0',
        maxWidth: '80%',
        alignSelf: 'flex-start',
        fontSize: '16px',
      }}>
        {(codeMessage?.message || '')
          .split('\n')
          .map((line, index, arr) => (
            <React.Fragment key={index}>
              {line}
              {index < arr.length - 1 && <br />}
            </React.Fragment>
          ))}
      </div>
    }
  </>
};

CustomerDocPicture.propTypes = {
};

export default CustomerDocPicture;